import React, { Component } from 'react';
import PropTypes from 'prop-types';
import api from '../../../../api/';
import Modal from "./Modal.js";
import ParadigmaTable from "../../../../components/ParadigmaTable/"
import Notificacion from "./Notificacion";
import ModalHabilitarMovil from './ModalHabilitarMovil';

class Vendedores extends Component {
    constructor(props) {
        super(props);
        this.state = {
            empresa:{},
            columns: [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    show: false,
                    private: true,
                },
                {
                    Header: "Nombre",
                    id: "Nombre",
                    accessor: d => d.Nombre,
                    width: 200,
                    show: true,
                },
                {
                    Header: "Email",
                    id: "Email",
                    accessor: d=>d.Email,
                    filterable: true,
                    width: 250,
                    show: true,
                },
                {
                    Header: "Telefono",
                    id: "Telefono",
                    accessor: d => d.Telefono,
                    filterable: true,
                    width: 200,
                    style:{textAlign:"center"},
                    show: true,
                },
                {
                    Header: "Habilitado",
                    id: "Habilitado",
                    className: "text-center",
                    accessor: d => (d.Habilitado == true ? "SI" : "NO"),
                    filterable: true,
                    show: true,
                    lookup:'exact',
                    Filter: ({ filter, onChange }) =>
                        <select
                            onChange={event => onChange(event.target.value)}
                            style={{ width: "100%" }}
                            value={filter ? filter.value : "TODOS"}>
                            <option value="">TODOS</option>
                            <option value="True">SI</option>
                            <option value="False">NO</option>
                        </select>,
                },
                {
                    Header: "En SIGE",
                    id: "en_sige",
                    className: "text-center",
                    accessor: d => (d.en_sige ? "SI" : "NO"),
                    filterable: true,
                    show: true,
                    lookup:'exact',
                    Filter: ({ filter, onChange }) =>
                        <select
                            onChange={event => onChange(event.target.value)}
                            style={{ width: "100%" }}
                            value={filter ? filter.value : "TODOS"}>
                            <option value="">TODOS</option>
                            <option value="True">SI</option>
                            <option value="False">NO</option>
                        </select>,
                },
                {
                    Header: "Movil",
                    id: "habilitadoMovil",
                    className: "text-center",
                    accessor: d => (d.habilitadoMovil == true ? "SI" : "NO"),
                    filterable: true,
                    show: true,
                    lookup:'exact',
                    Filter: ({ filter, onChange }) =>
                        <select
                            onChange={event => onChange(event.target.value)}
                            style={{ width: "100%" }}
                            value={filter ? filter.value : "TODOS"}>
                            <option value="">TODOS</option>
                            <option value="True">SI</option>
                            <option value="False">NO</option>
                        </select>,
                },
            ]
        };
    }

    static propTypes = {
        modernTheme: PropTypes.bool,
    }

    render() {
        const { modernTheme } = this.props;
        let empresa = this.state.empresa;
        return (
            <ParadigmaTable
                modernTheme={modernTheme}
                buttons={[
                    {
                        edit: true,
                        permission: 'ecommerce_ventas_vendedores_view',
                        component: (props) => <Modal {...props} action="EDIT" />,
                    },
                    {
                        detail: true,
                        permission: 'ecommerce_ventas_vendedores_view',
                        component: (props) => <Modal {...props}  action="DETAIL" />,
                    },
                    {
                        edit: true,
                        permission: 'ecommerce_ventas_vendedores_view',
                        component: (props) => <ModalHabilitarMovil {...props} action="HABILITAR_MOVIL" />,
                    },
                    {
                        edit: true,
                        permission: 'ecommerce_ventas_vendedores_view',
                        component: (props) => <Modal {...props} action="FORCE_UPDATE" />,
                    },
                    {
                        edit: true,
                        permission: 'ecommerce_ventas_vendedores_view',
                        component: (props) => <Notificacion {...props} />,
                    },
                ]}
                apiUrl={api.gestion.ventas.vendedores.vendedores}
                columns={this.state.columns}
                title={"Vendedores"}
            />
        );
    }
}

export default Vendedores;



// WEBPACK FOOTER //
// ./src/views/Gestion/Ventas/Vendedores/Vendedores.js